import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { PageData } from './page-data.interface';


@Component({
  moduleId: module.id,
  selector: 'pages-dropdown-menu',
  templateUrl: 'pages-dropdown-menu.component.html',
  styleUrls: ['pages-dropdown-menu.component.scss'],
})
export class PagesDropdownMenuComponent {
  @Input() data: Array<PageData> = [];
  @Input() menuSize: string = '';
  @Output() onRemoveItem: EventEmitter<any> = new EventEmitter();

  constructor(
    protected router: Router,
  ) {}

  isRouteActive(url: string): boolean {
    return this.router.isActive(url, false);
  }

  setActive(item: PageData) {
    _.each(this.data, (dataItem: PageData) => dataItem.active = false);
    item.active = true;
  }

  // handlers:
  onRemoveClick(event: MouseEvent, menuItem: any) {
    this.onRemoveItem.emit(menuItem);
  }

  onItemClick(event: any, item: PageData) {
    event.preventDefault();
    const target = event.target;
    if (!target.hasAttribute('data-js-remove-btn')) {
      this.router.navigate([item.link]);
      _.defer(() => this.setActive(item));
    }
    return false;
  }

}
